export const APP_TOUR_STARTED = 'started';
export const APP_TOUR_CANCELLED = 'cancelled';
export const APP_TOUR_HOMEPAGE_CODEREF = 'my_homepage';
